/* default makert 缓存方法，默认缓存到 session storage */
export const marketMap = {
  cacheKey: 'MARKET_MAP',
  data: {
    // 版本，用来控制主动更新
    version: '1'
  },
  init() {
    const localDataStr = sessionStorage.getItem(this.cacheKey)
    if (localDataStr) {
      const localData = JSON.parse(localDataStr)
      // 仅版本一致才返回
      const isValid = localData.version === this.data.version
      if (isValid) {
        Object.assign(this.data, localData)
      }
    }
  },
  set(sportId = '', value, { withOthers } = {}) {
    this.data[sportId] = {
      ...value,
      withOthers
    }
    sessionStorage.setItem(this.cacheKey, JSON.stringify(this.data))
  },
  get(sportId = '') {
    return this.data[sportId]
  },
  getMarket(sportId, marketId) {
    const sportMarket = this.get(sportId)
    return sportMarket && sportMarket.map[marketId]
  },
  addSpecialMarket(sportId, specialMarkets) {
    if (!this.data[sportId]) {
      this.data[sportId] = {}
    }
    Object.assign(this.data[sportId], { specialMarkets })
    sessionStorage.setItem(this.cacheKey, JSON.stringify(this.data))
  }
}

marketMap.init()
